// extracted by mini-css-extract-plugin
export var option = "_bz-0";
export var optionCard = "_bz-f";
export var optionContent = "_bz-g";
export var optionIcon = "_bz-i";
export var optionIconBox = "_bz-h";
export var optionLabel = "_bz-j";
export var optionPill = "_bz-m";
export var optionPillBadge = "_bz-p";
export var optionPillIcon = "_bz-n";
export var optionPillLabel = "_bz-o";
export var optionRadio = "_bz-k";
export var optionRadioInner = "_bz-l";
export var optionReveal = "_bz-2";
export var optionRevealDelay0 = "_bz-3";
export var optionRevealDelay1 = "_bz-4";
export var optionRevealDelay10 = "_bz-d";
export var optionRevealDelay11 = "_bz-e";
export var optionRevealDelay2 = "_bz-5";
export var optionRevealDelay3 = "_bz-6";
export var optionRevealDelay4 = "_bz-7";
export var optionRevealDelay5 = "_bz-8";
export var optionRevealDelay6 = "_bz-9";
export var optionRevealDelay7 = "_bz-a";
export var optionRevealDelay8 = "_bz-b";
export var optionRevealDelay9 = "_bz-c";
export var optionSelected = "_bz-1";